import { StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../application/UserProfile";
import { ColDef } from "../../grids/columns/colDef";
import {
  IRowCommandEventArgs,
  RecordGridController,
} from "../../grids/controller";
import { RecordDataSource } from "../../grids/recordDataSource";
import { IGridSettings } from "../../grids/settings/gridSettingsService";

export class RecordGridViewController {
  static $inject = ["userProfile", "$state"];

  gridDataSource!: RecordDataSource;
  gridSettings: IGridSettings | undefined;
  columns!: ColDef[];
  defaultSort: string | undefined;
  nameSingular: string = "";
  namePlural: string | undefined;
  showAddButton: boolean = false;
  showAddButtonPermission: string | string[] | undefined;
  onItemCommand: (args: IRowCommandEventArgs<unknown>) => void = () => {};
  onAddNew!: () => void;
  dropdownOptions: any[] = [];
  rowIdSelector: (locals: any) => number = (locals: any) =>
    RecordGridController.defaultRowIdSelector(locals);

  constructor(
    private readonly userProfile: UserProfile,
    private readonly $state: StateService,
  ) {}

  $onInit() {
    if (!this.namePlural) {
      this.namePlural = `${this.nameSingular}s`;
    }
    if (this.onAddNew === undefined) {
      this.onAddNew = () => this.$state.go(".add");
    }
  }

  add() {
    this.onAddNew();
  }

  shouldShowAddButton(): boolean {
    if (!this.showAddButton) return false;
    const permission = this.showAddButtonPermission;
    if (!permission) return true;

    if (Array.isArray(permission)) {
      return permission.reduce<boolean>(
        (value, next) => value && this.userProfile.hasPermission(next),
        true,
      );
    }

    return this.userProfile.hasPermission(permission);
  }
}
